import { animate, style, transition, trigger } from '@angular/animations';
import { EASE_IN_BACK, EASE_OUT_BACK } from '@shared/css.utils';

export const FADE_ANIMATION = (triggerAtAllTransitions: boolean) =>
  trigger('fade', [
    transition(triggerAtAllTransitions ? '* => *, :enter' : ':enter', [
      style({ opacity: 0 }),
      animate('0.25s ease-out', style({ opacity: 1 })),
    ]),
    transition(':leave', [style({ opacity: 1 }), animate('0.25s ease-out', style({ opacity: 0 }))]),
  ]);

export const MODAL_ANIMATION = (triggerAtAllTransitions: boolean) =>
  trigger('modal', [
    transition(triggerAtAllTransitions ? '* => *, :enter' : ':enter', [
      style({ scale: 0.75, opacity: 0 }),
      animate(`0.25s ${EASE_OUT_BACK}`, style({ opacity: 1, scale: 1 })),
    ]),
    transition(':leave', [style({ scale: 1, opacity: 1 }), animate(`0.25s ${EASE_IN_BACK}`, style({ opacity: 0, scale: 0.75 }))]),
  ]);

export const SLIDE_ANIMATION = (direction: 'left' | 'down') =>
  trigger(`slide${direction}`, [
    transition(':enter', [
      style({ transform: direction === 'left' ? `translateX(-100%)` : 'translateY(100%)' }),
      animate(`0.25s ${EASE_OUT_BACK}`, style({ transform: direction === 'left' ? `translateX(0)` : 'translateY(0)' })),
    ]),
    transition(':leave', [
      style({ transform: direction === 'left' ? `translateX(0)` : 'translateY(0)' }),
      animate(`0.25s ${EASE_IN_BACK}`, style({ transform: direction === 'left' ? `translateX(-100%)` : 'translateY(100%)' })),
    ]),
  ]);

export const CAROUSEL_ANIMATION = (duration: number) =>
  trigger(`carousel`, [
    transition(':enter', [
      style({ transform: `translateX(100%)` }),
      animate(`${duration}ms ${duration}ms ${EASE_OUT_BACK}`, style({ transform: `translateX(0)` })),
    ]),
    transition(':leave', [
      style({ transform: `translateX(0)` }),
      animate(`${duration}ms ${EASE_IN_BACK}`, style({ transform: `translateX(-100%)` })),
    ]),
  ]);
